import React from 'react';
import Programs from './containers/ProgramsContainer';


const ProgramsApp = () => <Programs />;

export default ProgramsApp;
